import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Ticket, TicketTask } from 'src/app/models';

export interface SprintBoardState {
  tickets: Ticket[];
  ticketTasks: TicketTask[];
  filteredTickets: TicketTask[];
  sprints: Record<string, any>;
  notPunctuatedSprint: Record<string, any>;
  punctuatedSprint: Record<string, any>;
  delayedAndFinishedSprint: Record<string, any>;
  delayedSprint: Record<string, any>;
  minimizedSprints: Record<string, any>;
  sprintOpenedUser: Record<string, boolean>;
  loading: boolean;
  activeDeveloper: string | null;
}

const buildInitialState = (): SprintBoardState => ({
  tickets: [],
  ticketTasks: [],
  filteredTickets: [],
  sprints: {},
  notPunctuatedSprint: {},
  punctuatedSprint: {},
  delayedAndFinishedSprint: {},
  delayedSprint: {},
  minimizedSprints: {},
  sprintOpenedUser: {},
  loading: false,
  activeDeveloper: null,
});

@Injectable({ providedIn: 'root' })
export class SprintStateService {
  private readonly stateSubject = new BehaviorSubject<SprintBoardState>(buildInitialState());
  readonly state$ = this.stateSubject.asObservable();

  select<K extends keyof SprintBoardState>(key: K): Observable<SprintBoardState[K]> {
    return this.state$.pipe(
      map(state => state[key]),
      distinctUntilChanged()
    );
  }

  get snapshot(): SprintBoardState {
    return this.stateSubject.getValue();
  }

  update(partial: Partial<SprintBoardState>): void {
    const nextState = {
      ...this.snapshot,
      ...partial,
    };

    this.stateSubject.next(nextState);
  }

  reset(): void {
    this.stateSubject.next(buildInitialState());
  }
}
